module.exports = __webpack_public_path__ + "img/Ellipse-294.3dc0d60e.svg";